<template>
    <div>
        <b-table :items="availableAcceptances" :fields="availableAcceptancesFields" show-empty
            empty-text="No acceptances available for patient" class="mb-0">
            <template #cell(actions)="{ item }">
                <div class="table-icon-actions">
                    <a v-if="!item.requiresSignature" href="#" @click.prevent="selectedConfig = item">
                        <b-icon icon="plus-circle" v-b-tooltip.hover title="Add Acceptance Record" />
                    </a>
                </div>
            </template>
        </b-table>

        <b-modal :visible="!!selectedConfig" title="Add Acceptance Record" ok-title="Add Acceptance Record"
            @hidden="selectedConfig = null" no-fade centered @ok="addAcceptance">
            <template v-if="selectedConfig">
                Add an acceptance record for <strong>{{ selectedConfig.name }}</strong> for this patient?
            </template>
        </b-modal>
    </div>
</template>

<script lang="ts">
import { AcceptanceConfiguration } from '@/models/AcceptanceConfiguration';
import { Patient } from '@/models/Patient';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';
import axios from 'axios';
import { BvModalEvent } from 'bootstrap-vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
    components: {

    },
})
export default class AvailableAcceptanceListComponent extends Vue {

    @Prop({ required: true }) protected patient!: Patient;

    mounted() {
        this.loadAvailableAcceptances();
    }

    protected availableAcceptances: AcceptanceConfiguration[] = [];
    protected selectedConfig: AcceptanceConfiguration | null = null;

    get availableAcceptancesFields() {
        const boolFormatter = (value: boolean) => value ? "✔️" : "";
        return [
            { key: "name" },
            { key: "mandatory", formatter: boolFormatter },
            { key: "recurring", formatter: boolFormatter },
            { key: "requiresSignature", formatter: boolFormatter },
            { key: "actions", label: "", class: "actions-col" }
        ]
    }

    @Watch("patient")
    async loadAvailableAcceptances() {
        if (!this.patient?.id) {
            this.availableAcceptances = [];
            return;
        }
        try {
            const resp = await axios.get<AcceptanceConfiguration[]>(`Patient/AvailableAcceptanceConfigs/${this.patient.id}`);
            this.availableAcceptances = resp.data;
        } catch (err) {
            console.error(err);
            this.$notification(NotificationOptions.error(err));
            this.availableAcceptances = [];
        }
    }

    async addAcceptance(e: BvModalEvent) {
        e.preventDefault();

        try {
            await axios.post(`Patient/AddAcceptance/${this.patient.id}/${this.selectedConfig!.id}`);
            this.$notification(NotificationOptions.success("Added acceptance"));
            this.loadAvailableAcceptances();
            this.selectedConfig = null;
            this.$emit("update");
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
            console.error(err);
        }
    }

}

</script>

<style scoped>
::v-deep(.actions-col) {
    width: 30px;
}
</style>